import FilePickerUpload from "lib/core/components/file-picker-upload/FilePickerUpload"

const SubmissionFileUpload = function (props) {
  const { submission_file_type, completion, onFileSubmitted } = props
  const mediaType = submission_file_type || "file"
  let file = null
  if (completion.submission_file_url) {
    file = {
      filename: completion.submission_file_name,
      url: completion.submission_file_url
    }
  }

  return (
    <div className="SubmissionFileUpload">
      <FilePickerUpload
        file={file}
        mediaType={mediaType}
        onFileUploaded={onFileSubmitted}
      />
    </div>
  )
}

SubmissionFileUpload.displayName = "SubmissionFileUpload"

export default SubmissionFileUpload
